import ApiService from "./ApiService";

const CashAdvanceService = {
  listCashAdvance: async (rowsPerPage, page) => {
    const params = { pageSize: rowsPerPage, pageNumber: page };
    return ApiService.get("cash-advances", params);
  },

  getCashAdvance: async (uuid) => {
    return ApiService.get("cash-advances/" + uuid);
  },

  signCashAdvance: async (simulationUuid) => {
    return ApiService.post(
      "cash-advances/v1/documents/" + simulationUuid + "/sign"
    );
  },

  createDocuments: async (simulationUuid, documentType) => {
    const params = {
      cashAdvanceSimulationUuid: simulationUuid,
      type: documentType,
    };
    return ApiService.post("cash-advances/v1/documents/", params);
  },

  simulation: async (receivablesUuid) => {
    const params = { receivablesUuid: receivablesUuid };
    return ApiService.post('cash-advance-simulation/', params);
  },

  downloadBoleto: async (path) => {
    return ApiService.get('cash-advances/v1/charges/boleto/'+path);
  },
};

export default CashAdvanceService;
